import styled from '@emotion/styled';
import SectionContentGroupContext from './SectionContentGroupContext';
import ContentGroupType from '@/lib/constants/challengeModel/ContentGroupType.enum';
import React from 'react';
import { type HTMLDivProps } from '@/lib/types';

type SectionBottomContentProps = HTMLDivProps & {
  children: React.ReactNode;
};

const StyledBottomContent = styled('footer')({
  marginTop: 24,
});

const SectionBottomContent = (props: SectionBottomContentProps) => (
  <SectionContentGroupContext.Provider value={ContentGroupType.BOTTOM}>
    <StyledBottomContent {...props} />
  </SectionContentGroupContext.Provider>
);

export default SectionBottomContent;
